import React, { useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { ReviewType } from "../../../../types";
import { ReviewListProps } from "../../Default/ReviewsList";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { BsStar, BsStarFill } from "react-icons/bs";
import ReviewItem from "./ReviewItem";
import { getReviews } from "../../../../services/ecommerceApi";

const ReviewList = ({ reviews, count: externalCount = 10 }: ReviewListProps) => {

    const count = externalCount > 0 ? externalCount : 10;

    const data = useStaticQuery(graphql`
        query {
            allReview(limit: 20) {
                nodes {
                author
                body
                customer
                customerName
                datePublished
                }
            }
        }
    `);

    const [items, setItems] = React.useState<ReviewType[]>([...(data?.allReview?.nodes || []), ...(reviews || [])]);

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        const live = await getReviews(count);
        setItems([...(reviews || []), ...(live || items)]);
    }

    const filteredReviews = items?.slice(0, count);
    return (
        <div className="-mx-3">
            <Splide
                options={{
                    autoplay: false,
                    type: "loop",
                    perPage: 3,
                    pagination: false,
                    gap: "2rem",
                    padding: "3rem",
                    breakpoints: {
                        640: {
                            perPage: 1,
                            type: "loop",
                            padding: 50,
                            gap: 120,
                            arrows: false,
                        }
                    }
                }}
            >
                {filteredReviews?.map((review) => (
                    <SplideSlide key={review.id}>
                        <div key={review.id + "item"} className="px-4" >
                            <ReviewItem key={review.id + "item2"} review={review} />
                        </div>
                    </SplideSlide>
                ))}
            </Splide>

        </div>
    );
};

export default ReviewList;
